import React from 'react';

export const adminRouteConfig = [
  {
    routes: [
      {
        path: '/admins',
        component: React.lazy(() => import('./AdminList')),
      },
    ],
  },
];
